import { Outlet } from 'react-router-dom';
import Navbar from '../components/nav/Navbar';
import './DashboardLayouts.scss';


const DashboardLayout = () => {
 

  
  

  return (
    <div className="dashboard-layout-container">
      <Navbar />
      <div className="dashboard-layout-children">
        <div className="dashboard-layout-inner-wrapper">
          <Outlet />
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
          padding: "20px 0",
          fontFamily: "Avenir Next, Neue Montreal, sans-serif",
          fontWeight: "500",
          fontSize: "12px",
          lineHeight: "120%",
          letterSpacing: "2%",
          verticalAlign: "middle",
          textTransform: "uppercase",
          color: "#727279",
          marginTop: "40px",
        }}
      >
        © 2024 Care plan 365
      </div>
    </div>
  );
};

export default DashboardLayout;
